<template>
    <div>

        <TextBanner>
       <p> Mehr als 400 km über uns forschen <b>insgesamt 16 Nationen</b> gemeinsam im All. Seit 2000 halten sich ununterbrochen Astronauten hier auf.</p>
        <b>Drehen Sie das Modell und entdecken Sie, welche Nationen an der ISS beteiligt sind.</b>
        </TextBanner>

        <InfoBox modalName="Roskosmo">
            <template #title>Russische Weltraumbehörde Roskosmos</template>
            <template #subline></template>
            <template>

                <p>Das <b>erste Modul</b> für die Internationale Raumstation wurde in Russland gebaut und von der amerikanischen Raumfahrtbehörde Nasa finanziert. Seit 1994 arbeiten die beiden Weltraumbehörden zusammen.</p>


                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_module.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="650" data-height="496" v-lazy="require('../assets/img/010_module_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; ap</div>
                            Mit den beiden Modulen ist die Raumstation funktionstüchtig. Mit einer eigenen Stromversorgung und einer Umgebung, in der sich Astronauten ohne Raumanzug aufhalten können
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p><b>Am 20. November 1998</b> brachte eine russische Trägerrakete das <b>Modul „Sarja“</b> – übersetzt Morgenröte – ins All. Kurz danach dockte das zweite <b>amerikanische Modul „Unity“</b> – übersetzt Einheit - an.  Sarja und Unity waren die ersten beiden der später mehr als 30 einzelnen Module.</p>

                <p>Insgesamt brauchte es 42 Flüge, bis alle Einzelteile transportiert waren.</p>




            </template>
        </InfoBox>

        <InfoBox modalName="Nasa">
            <template #title>US-Weltraumbehörde Nasa</template>
            <template #subline></template>
            <template>
                <p>Der überwiegende Teil der ISS wurde von und mit der US-Weltraumbehörde Nasa gebaut. Sie wurde 1984 vom damaligen US-Präsidenten Ronald Reagan mit der Entwicklung einer dauerhaft besetzten Raumstation beauftragt. Seit 2011 ist die ISS offiziell fertig.</p>



                <!-- Bild -->
                <figure>
                    <img class="img-fluid" src="../assets/img/010_reagan_thumb.jpg" alt="">
                    <figcaption>
                        <div class="legal">&copy; Nasa</div>
                        US-Präsident Ronald Reagan im Nasa Kontrollraum, 1984
                    </figcaption>
                </figure>

                <p>Das Ziel: die Wissenschaft, die industrielle Forschung sowie die Herstellung von Metallen und Medikamenten voranzutreiben. Das riesige Labor kostet drei bis vier Milliarden Dollar pro Jahr.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_iss.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="381" v-lazy="require('../assets/img/010_iss_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Roskosmos</div>
                            Die Internationale Raumstation fotografiert aus der Soyuz MS-18, 2021  
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p><b>China</b> ist wegen eines Beschlusses der USA nicht an der Internationalen Raumstation beteiligt. <b>Brasilien</b> hat mit der Nasa ein eigenes Abkommen für die ISS.</p>

            </template>
        </InfoBox>

        <InfoBox modalName="CSAASC">
            <template #title>Kanadische Weltraumbehörde CSA</template>
            <template #subline></template>
            <template>
                <p>Die Canadian Space Agency ist mit dem kleinsten Anteil an dem Betrieb der ISS beteiligt. Sichtbar wird dieser mit dem <b>Greifarm Canadarm2</b>. Mit diesem Arm können Transport-, Wartungs- und Reparaturarbeiten außerhalb der ISS durchgeführt werden. Seit 2001 ist der 17,6 Meter lange Arm im Einsatz.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_canadarm.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="650" data-height="433" v-lazy="require('../assets/img/010_canadarm_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>

            </template>
        </InfoBox>

        <InfoBox modalName="Jaxa">
            <template #title>Japanische Weltraumbehörde JAXA</template>
            <template #subline></template>
            <template>
                <p>Das größte Einzelmodul der ISS ist „Kibo“ – übersetzt Hoffnung. Das japanische Modul kann bis zu vier Raumfahrer aufnehmen und ist seit 2008 im All. Für die Japaner ist diese Mission die erste mit bemannter Raumfahrt.</p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_kibo.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="581" data-height="444" v-lazy="require('../assets/img/010_kibo_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; jaxa/NASA</div>
                            Das japanische Modul Kibo im All, 2010
                        </figcaption>
                    </figure>
                </FullscreenImage>


                <p>In der Vergangenheit existierten drei japanische Raumfahrtagenturen nebeneinander, bevor sie sich 2003 zur neuen <b>Japan Aerospace Exploration Agency</b> (JAXA) zusammenschlossen.</p>

            </template>
        </InfoBox>

        <InfoBox modalName="ESA">
            <template #title>Europäische Weltraumbehörde Esa</template>
            <template #subline></template>
            <template>
                <p>Von Anfang an dabei war die europäische Weltraumbehörde Esa, die 1985 die Beteiligung an der neuen Raumstation im All beschloss. Übrigens hieß die Raumstation zu Beginn <b>Freedom</b> - Freiheit auf Deutsch - bevor sie schlussendlich auf den Namen <b>International Space Station</b> getauft wurde.</p>

                <p>Insgesamt elf Länder gehören zum Esa-Programm: Belgien, Dänemark, Deutschland, Frankreich, Italien, Niederlande, Norwegen, Schweden, Schweiz, Spanien und das Vereinigte Königreich. </p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/010_columbus.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="650" data-height="366" v-lazy="require('../assets/img/010_columbus_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                            Blick von einer Raumfähre auf das Columbus-Labor                        
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>Herzstück ist das europäische Modul Columbus. Weiter beteiligt sich die Esa mit Verbindungsteilen und Laborgeräten, die in der Kooperation mit den anderen Ländern geliefert und an die ISS angebunden werden.</p>

            </template>
        </InfoBox>


        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_040_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_040_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot hotspot--roskosmos" v-on:click="infobox('Roskosmo')"></div>
            <div class="hotspot hotspot--nasa" v-on:click="infobox('Nasa')"></div>
            <div class="hotspot hotspot--csaasc" v-on:click="infobox('CSAASC')"></div>
            <div class="hotspot hotspot--jaxa" v-on:click="infobox('Jaxa')"></div>
            <div class="hotspot hotspot--esa" v-on:click="infobox('ESA')"></div>




        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [1.57,1,30],   //[1.57,.8,35],        21.10./14h [1.57,1,20]   schräg unten:0.63,2.1,44
                target: [.5,-4,0],       //[.5,-2,0]            21.10./14h  [.5,-2,1]       schräg unten:.5,-2,0
                // position: [1.57,1,20],   //[1.57,.8,35],        21.10./14h [1.57,1,20]
                // target: [.5,-2,1]     
            },

            iss: {


                // Empty: {
                //     sonne: {
                //         fade: true,
                //         visible: false
                //     },
                // },


                // erde_pivot: {
                //     erde: {
                //         fade: true,
                //         visible: false
                //     },
                // },

                Flagge_Russland: {
                    visible: true,
                    //billboardMode: 2,
                    // position: [.5,0,-2],
                    // renderingGroupId: 1
                },

                Flagge_USA: {
                    visible: true,
                    //billboardMode: 2,
                    // position: [-2,0,2],
                    // renderingGroupId: 1

                },

                Flagge_USA_back: {
                    visible: true,
                    //billboardMode: 2,
                    // position: [-2,0,2],
                    // renderingGroupId: 1
                },

                Flagge_EU: {
                    visible: true,
                    //billboardMode: 2,
                    // position: [2,0,6],
                    // renderingGroupId: 1
                },

                Flagge_Japan: {
                    visible: true,
                    //billboardMode: 2,
                    // position: [-3,0,7],
                    // renderingGroupId: 1

                },

                Flagge_Kanada: {
                    visible: true,
                    //billboardMode: 2,
                    // position: [5,0,3],
                    // renderingGroupId: 1
                },



                   
                Canadarm_merge: {
                    overlayColor: [58/255, 191/255, 178/255],
                    overlayAlpha: 0.8
                },


                ELM_Kibo: {
                    overlayColor: [200/255, 200/255, 10/255],
                    overlayAlpha: 0.6,
                },

                Swesta: {
                    overlayColor: [220/255, 52/255, 109/255],
                    overlayAlpha: 0.6,

                    Panels_Swesta_solar: {
                        overlayColor: [220/255, 52/255, 109/255],
                        overlayAlpha: 0.6
                    }
                },

                Poisk: {
                    overlayColor: [220/255, 52/255, 109/255],
                    overlayAlpha: 0.6,
                    },

                Nauka: {
                    overlayColor: [220/255, 52/255, 109/255],
                    overlayAlpha: 0.6,
                    ERA_Roboterarm: {
                        overlayColor: [20/255, 192/255, 216/255],
                        overlayAlpha: 0.6,
                    },
                    
                    Panels_Nauka_solar:{
                            overlayColor: [220/255, 52/255, 109/255],
                            overlayAlpha: 0.6,
                    },

                },

                Zarya: {
                    overlayColor: [220/255, 52/255, 109/255],
                    overlayAlpha: 0.6,
                    Solarpanels_Zarya_solar:{
                            overlayColor: [220/255, 52/255, 109/255],
                            overlayAlpha: 0.6,
                            },
                    },

                Kopplung_Swesta: {
                    overlayColor: [220/255, 52/255, 109/255],
                    overlayAlpha: 0.6,
                },

                Columbus: {
                    overlayColor: [48/255, 200/255, 242/255],
                    overlayAlpha: 0.6
                },

            },    

            hotspots: {
                Russland: {
                    visible: true,
                    infoBox: 'Roskosmo',
                    position: [.5, .5, -8],
                    scale: 3,
                    renderingGroupId: 0
                },

                USA: {
                    visible: true,
                    infoBox: 'Nasa',
                    position: [-1.5, 1, .2],
                    scale: 3, //3
                    renderingGroupId: 0
                },

                Japan: {
                    visible: true,
                    infoBox: 'Jaxa',
                    position: [-4, -2, 5.5],
                    scale: 3,
                    renderingGroupId: 0
                },

                Kanada: {
                    visible: true,
                    infoBox: 'CSAASC',
                    position: [3.4, 3.7, 3],
                    scale: 3,
                    renderingGroupId: 0
                },

                Europa: {
                    visible: true,
                    infoBox: 'ESA',
                    position: [3, -2, 5],
                    scale: 3,
                    renderingGroupId: 0
                },

            },
           
        },
        babylonReady: function () {

        this.$babylonController.goToAnimation("spacex_anim", 0);

        this.$babylonController.timer.add(1800, () => {
            this.$babylonController.setCameraRadiusLimit(20,200);
        });

        //this.$audioController.initTrack('speaker', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);
        //this.$audioController.play('./../assets/audio/2496003_Starhorizon_192.mp3')


        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot--roskosmos {

        left: 80vw;
        top: 30vh;

        @media (orientation: landscape) {
            left: 63vw;
            top: 20vh;
            transform: scale(0.75);
        }
    }

    .fallback-container .hotspot--esa {

        left: 10vw;
        top: 50vh;

        @media (orientation: landscape) {
            left: 18vw;
            top: 48vh;
            transform: scale(0.75);
        }
    }


    .fallback-container .hotspot--jaxa {

        left: 35vw;
        top: 65vh;

        @media (orientation: landscape) {
            left: 40vw;
            top: 70vh;
            transform: scale(0.75);
        }
    }

    .fallback-container .hotspot--nasa {

        left: 53vw;
        top: 36vh;

        @media (orientation: landscape) {
            left: 45vw;
            top: 32vh;
            transform: scale(0.75);
        }
    }

    .fallback-container .hotspot--csaasc {

        left: 16vw;
        top: 20vh;

        @media (orientation: landscape) {
            left: 20vw;
            top: 10vh;
            transform: scale(0.75);
        }
    }



</style>
